<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->

<ods-dropdown-menu
  #dropdown
  data-test-id="user-profile-dropdown"
  [buttonTooltip]="userButtonTooltip"
  buttonVariant="user-profile"
  buttonSize="extra-small"
>
  <alfa-user-icon
    button-content
    data-test-id="user-profile-icon"
    [userProfileStateResource]="userProfile()"
    [hasTooltip]="false"
  />
  @if (dropdown.isOpen) {
    <ods-dropdown-menu-item padding="bottom-large" class="w-80">
      <alfa-user-profile-vorgang-user [userProfile]="userProfile()" />
    </ods-dropdown-menu-item>
    <ods-dropdown-menu-item data-test-id="user-profile-dropdown-item" padding="large" background="white">
      <alfa-user-profile-search-container data-test-id="user-profile-search-container" />
    </ods-dropdown-menu-item>
  }
</ods-dropdown-menu>
